import { Injectable } from "@angular/core";
import { EMPTY, Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";

import { Helper, parseApiResponseObject2 } from "@helpers/functions";
import { ApicallService } from "@core-services/apicall.service";
import { BestTokenBurnModel } from "../entities/best-token-burn.model";
import { BestModel } from "../entities/best.model";
import { BEST_VIP_LEVEL_1_MIN_AMOUNT } from "@helpers/constants";

interface BestTokenBurnApi {
	next_burn: BestTokenBurnModel;
	previous_burns: BestTokenBurnModel[];
}

@Injectable({
	providedIn: "root"
})
export class BestRemote {
	constructor(private readonly apiCallService: ApicallService) {}

	public getBestTokenBurn$(): Observable<BestTokenBurnApi> {
		// @TODO Properly deserialize using adapter approach
		return this.apiCallService.get("best-token-burns").pipe(
			map((btbs) => parseApiResponseObject2<BestTokenBurnApi>(btbs)),
			catchError((e) => {
				Helper.handleError(e);
				return EMPTY;
			})
		);
	}

	public getBest$(): Observable<BestModel> {
		return this.apiCallService.get("user/best-rewards").pipe(
			map((result) => parseApiResponseObject2<BestModel>(result)),
			map((result) => {
				// on VIP level 0, these properties don't exist on the endpoint so we set them manually
				if (+result.balance < BEST_VIP_LEVEL_1_MIN_AMOUNT) {
					result = {
						...result,
						all_trade_bonus_levels: [],
						all_weekly_vip_levels: [],
						has_reached_max_trade_volume: false,
						has_reached_max_vip_level: false,
						next_vip_levels_threshold_trade: BEST_VIP_LEVEL_1_MIN_AMOUNT - +result.balance + ""
					};
				}

				// these fields disappear on trade/vip level 5, so we set them to null (to override state)

				if (!result.next_trade_crypto) {
					result = {
						...result,
						next_trade_crypto: null
					};
				}

				if (!result.next_trade_stocks) {
					result = {
						...result,
						next_trade_stocks: null
					};
				}

				if (!result.next_vip_levels_threshold_trade) {
					result = {
						...result,
						next_vip_levels_threshold_trade: null
					};
				}

				return result;
			})
		);
	}
}
